export const hcIcons = [
  {
    allergy: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Runny nose",
            icon: "/images/icons/HC-icons/Allergies/runny-nose.svg",
          },
          {
            id: 2,
            symptom: "Sneezing",
            icon: "/images/icons/HC-icons/Allergies/sneezing.svg",
          },
          {
            id: 3,
            symptom: "Coughing",
            icon: "/images/icons/HC-icons/Allergies/coughing.svg",
          },
          {
            id: 4,
            symptom: "Wheezing",
            icon: "/images/icons/HC-icons/Allergies/wheezing.svg",
          },
          {
            id: 5,
            symptom: "Breathlessness",
            icon: "/images/icons/HC-icons/Allergies/breathlessness.svg",
          },
          {
            id: 6,
            symptom: "Itchy skin/rash",
            icon: "/images/icons/HC-icons/Allergies/itchy-skin-and-rash.svg",
          },
          {
            id: 7,
            symptom: "Diarrhoea",
            icon: "/images/icons/HC-icons/Allergies/diarrhoea.svg",
          },
          {
            id: 8,
            symptom: "Feeling sick",
            icon: "/images/icons/HC-icons/Allergies/feeling-sick.svg",
          },
          {
            id: 9,
            symptom: "Swollen eyes, lips, mouth, and throat",
            icon: "/images/icons/HC-icons/Allergies/swollen-eyes-lips-mouth-and-throat.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Certain foods",
            icon: "/images/icons/HC-icons/Allergies/certain-foods.svg",
          },
          {
            id: 2,
            symptom: "Pets",
            icon: "/images/icons/HC-icons/Allergies/pets.svg",
          },
          {
            id: 3,
            symptom: "Dust mites",
            icon: "/images/icons/HC-icons/Allergies/dust-mites.svg",
          },
          {
            id: 4,
            symptom: "Pollen",
            icon: "/images/icons/HC-icons/Allergies/cockroaches.svg",
          },
          {
            id: 5,
            symptom: "Molds",
            icon: "/images/icons/HC-icons/Allergies/molds.svg",
          },
          {
            id: 6,
            symptom: "Medications",
            icon: "/images/icons/HC-icons/Allergies/medications.svg",
          },
          {
            id: 7,
            symptom: "Diseases (Example:Asthma)",
            icon: "/images/icons/HC-icons/Allergies/asthma.svg",
          },
          {
            id: 8,
            symptom: "Stinging insects",
            icon: "/images/icons/HC-icons/Allergies/stinging-insects.svg",
          },
          {
            id: 9,
            symptom: "Family history",
            icon: "/images/icons/HC-icons/Allergies/family-history.svg",
          },
        ],
      },
    ],
    arthritis: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Pain",
            icon: "/images/icons/HC-icons/Arthritis/pain.svg",
          },
          {
            id: 2,
            symptom: "Stiffness",
            icon: "/images/icons/HC-icons/Arthritis/stiffness.svg",
          },
          {
            id: 3,
            symptom: "Redness",
            icon: "/images/icons/HC-icons/Arthritis/redness.svg",
          },
          {
            id: 4,
            symptom: "Swelling",
            icon: "/images/icons/HC-icons/Arthritis/swelling.svg",
          },
          {
            id: 5,
            symptom: "Tenderness",
            icon: "/images/icons/HC-icons/Arthritis/tenderness.svg",
          },
          {
            id: 6,
            symptom: "Warmth at the joint site",
            icon: "/images/icons/HC-icons/Arthritis/warmth-at-the-joint-site.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Advanced Age",
            icon: "/images/icons/HC-icons/Arthritis/advanced-age.svg",
          },
          {
            id: 2,
            symptom: "Sedentary Lifestyle ",
            icon: "/images/icons/HC-icons/Arthritis/sedentary-lifestyle.svg",
          },
          {
            id: 3,
            symptom: "Family History",
            icon: "/images/icons/HC-icons/Arthritis/family-history.svg",
          },
          {
            id: 4,
            symptom: "Excessive Weight",
            icon: "/images/icons/HC-icons/Arthritis/excessive-weight.svg",
          },
          {
            id: 5,
            symptom:
              "Occupation with repeated joint stress (Example: Sportsperson)",
            icon: "/images/icons/HC-icons/Arthritis/occupation-with-repeated-joint-stress.svg",
          },
          {
            id: 6,
            symptom: "Autoimmune disorders ",
            icon: "/images/icons/HC-icons/Arthritis/autoimmune-disorders.svg",
          },
          {
            id: 7,
            symptom: "Viral infections",
            icon: "/images/icons/HC-icons/Arthritis/viral-infections.svg",
          },
        ],
      },
    ],
    asthma: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Shortness of breath",
            icon: "/images/icons/HC-icons/Asthma/shortness-of-breath.svg",
          },
          {
            id: 2,
            symptom: "Chest pain or tightness",
            icon: "/images/icons/HC-icons/Asthma/chest-pain-or-tightness.svg",
          },
          {
            id: 3,
            symptom: "Cough (especially at night)",
            icon: "/images/icons/HC-icons/Asthma/cough.svg",
          },
          {
            id: 4,
            symptom: "Wheezing ",
            icon: "/images/icons/HC-icons/Asthma/wheezing.svg",
          },
          {
            id: 5,
            symptom: "Difficulty in sleeping ",
            icon: "/images/icons/HC-icons/Asthma/difficulty-in-sleeping.svg",
          },
          {
            id: 6,
            symptom: "Frequently experiencing asthma signs and symptoms",
            icon: "/images/icons/HC-icons/Asthma/frequently-experiencing-asthma-signs-and-symptoms.svg",
          },
          {
            id: 7,
            symptom: "Increased difficulty in breathing",
            icon: "/images/icons/HC-icons/Asthma/increased-difficulty-in-breathing.svg",
          },
          {
            id: 8,
            symptom: "Increased usage of quick-relief inhaler",
            icon: "/images/icons/HC-icons/Asthma/increased-usage-of-quick-relief-inhaler.svg",
          },
          {
            id: 9,
            symptom: "Cyanosis (bluish discolouration of skin and face)",
            icon: "/images/icons/HC-icons/Asthma/cyanosis.svg",
          },
          {
            id: 10,
            symptom: "Decreased level of alertness ",
            icon: "/images/icons/HC-icons/Asthma/decreased-level-of-alertness.svg",
          },
          {
            id: 11,
            symptom: "Rapid pulse ",
            icon: "/images/icons/HC-icons/Asthma/rapid-pulse.svg",
          },
          {
            id: 12,
            symptom: "Severe anxiety ",
            icon: "/images/icons/HC-icons/Asthma/severe-anxiety.svg",
          },
          {
            id: 13,
            symptom: "Sweating",
            icon: "/images/icons/HC-icons/Asthma/sweating.svg",
          },
          {
            id: 14,
            symptom: "Difficulty speaking",
            icon: "/images/icons/HC-icons/Asthma/difficulty-speaking.svg",
          },
          {
            id: 15,
            symptom: "Breathing stops temporarily ",
            icon: "/images/icons/HC-icons/Asthma/breathing-stops-temporarily.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Airborne allergens",
            icon: "/images/icons/HC-icons/Asthma/airborne-allergens.svg",
          },
          {
            id: 2,
            symptom: "Excessive physical activity  ",
            icon: "/images/icons/HC-icons/Asthma/excessive-physical-activity.svg",
          },
          {
            id: 3,
            symptom: "Exposure to cold air",
            icon: "/images/icons/HC-icons/Asthma/exposure-to-cold-air.svg",
          },
          {
            id: 4,
            symptom: "Respiratory infections such as flu or common cold",
            icon: "/images/icons/HC-icons/Asthma/respiratory-infections-such-as-flu.svg",
          },
          {
            id: 5,
            symptom: "Irritants and air pollutants such as smoke",
            icon: "/images/icons/HC-icons/Asthma/irritants-and-air-pollutants.svg",
          },
          {
            id: 6,
            symptom: "Certain medications(NSAIDS and beta-blockers) ",
            icon: "/images/icons/HC-icons/Asthma/certain-medications.svg",
          },
          {
            id: 7,
            symptom: "Stress and strong emotions",
            icon: "/images/icons/HC-icons/Asthma/stress-and-strong-emotions.svg",
          },
          {
            id: 8,
            symptom: "Change in the weather (winter)",
            icon: "/images/icons/HC-icons/Asthma/change-in-the-weather.svg",
          },
          {
            id: 9,
            symptom: "Preservatives in certain foods and beverages",
            icon: "/images/icons/HC-icons/Asthma/preservatives-in-certain-foods-and-beverages.svg",
          },
          {
            id: 10,
            symptom: "Gastroesophageal reflux disease (GERD) ",
            icon: "/images/icons/HC-icons/Asthma/gastroesophageal-reflux-disease.svg",
          },
          {
            id: 11,
            symptom: "Family history of allergies (e.g. allergic rhinitis)",
            icon: "/images/icons/HC-icons/Asthma/family-history-of-allergies.svg",
          },
        ],
      },
    ],
    cancer: [
      {
        earlyStage: [
          {
            id: 1,
            symptom: "Unexplained weight loss",
            icon: "/images/icons/HC-icons/Cancer/unexplained-weight-loss.svg",
          },
          {
            id: 2,
            symptom: "Chronic tiredness",
            icon: "/images/icons/HC-icons/Cancer/chronic-tiredness.svg",
          },
          {
            id: 3,
            symptom: "Persistent pain",
            icon: "/images/icons/HC-icons/Cancer/persistent-pain.svg",
          },
          {
            id: 4,
            symptom: "Night fever ",
            icon: "/images/icons/HC-icons/Cancer/night-fever.svg",
          },
          {
            id: 5,
            symptom: "Skin changes, particularly moles ",
            icon: "/images/icons/HC-icons/Cancer/skin-changes-particularly-moles.svg",
          },
        ],

        lateStage: [
          {
            id: 1,
            symptom: "Bruising or bleeding more easily ",
            icon: "/images/icons/HC-icons/Cancer/bruising -or-bleeding-more-easily.svg",
          },
          {
            id: 2,
            symptom: "Lumps/bumps under the skin that persists ",
            icon: "/images/icons/HC-icons/Cancer/lumps-bumps-under-the-skin-that-persists.svg",
          },
          {
            id: 3,
            symptom: "Breathing difficulty",
            icon: "/images/icons/HC-icons/Cancer/breathing-difficulty.svg",
          },
          {
            id: 4,
            symptom: "Swallowing difficulty ",
            icon: "/images/icons/HC-icons/Cancer/swallowing-difficulty.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Smoking",
            icon: "/images/icons/HC-icons/Cancer/smoking.svg",
          },
          {
            id: 2,
            symptom: "High sugar/fat diet",
            icon: "/images/icons/HC-icons/Cancer/high-sugar-fat-diet.svg",
          },
          {
            id: 3,
            symptom: "Exposure to asbestos, pesticides or radon",
            icon: "/images/icons/HC-icons/Cancer/exposure-to-asbestos-pesticides-or-radon.svg",
          },
          {
            id: 4,
            symptom: "Radiation exposure",
            icon: "/images/icons/HC-icons/Cancer/radiation-exposure.svg",
          },
          {
            id: 5,
            symptom: "Hormone therapy",
            icon: "/images/icons/HC-icons/Cancer/hormone-therapy.svg",
          },
          {
            id: 6,
            symptom: "Genetics",
            icon: "/images/icons/HC-icons/Cancer/genetics.svg",
          },
        ],
      },
    ],
    covid: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Fever or chills",
            icon: "/images/icons/HC-icons/COVID/fever-chills.svg",
          },
          {
            id: 2,
            symptom: "Cough",
            icon: "/images/icons/HC-icons/COVID/cough.svg",
          },
          {
            id: 3,
            symptom: "Breathing difficulty",
            icon: "/images/icons/HC-icons/COVID/breathing-difficulty.svg",
          },
          {
            id: 4,
            symptom: "Fatigue",
            icon: "/images/icons/HC-icons/COVID/fatigue.svg",
          },
          {
            id: 5,
            symptom: "Body aches",
            icon: "/images/icons/HC-icons/COVID/body-aches.svg",
          },
          {
            id: 6,
            symptom: "Headache",
            icon: "/images/icons/HC-icons/COVID/headache.svg",
          },
          {
            id: 7,
            symptom: "Loss of taste and smell",
            icon: "/images/icons/HC-icons/COVID/loss-of-taste-and-smell.svg",
          },
          {
            id: 8,
            symptom: "Sore throat",
            icon: "/images/icons/HC-icons/COVID/sore-throat.svg",
          },
          {
            id: 9,
            symptom: "Runny nose/congestion",
            icon: "/images/icons/HC-icons/COVID/runny-nose.svg",
          },
          {
            id: 10,
            symptom: "Nausea/vomiting",
            icon: "/images/icons/HC-icons/COVID/nausea-vomiting.svg",
          },
          {
            id: 11,
            symptom: "Diarrhoea",
            icon: "/images/icons/HC-icons/COVID/diarrhoea.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Older adults",
            icon: "/images/icons/HC-icons/COVID/older-adults.svg",
          },
          {
            id: 2,
            symptom: "Heart conditions ",
            icon: "/images/icons/HC-icons/COVID/people-with-underlying-health-conditions.svg",
          },
          {
            id: 3,
            symptom: "Immunocompromised individuals",
            icon: "/images/icons/HC-icons/COVID/immunocompromised-individuals.svg",
          },
          {
            id: 4,
            symptom: "Pregnant women",
            icon: "/images/icons/HC-icons/COVID/pregnant-women.svg",
          },
        ],
      },
    ],
    diabetes: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Feeling more thirsty than usual",
            icon: "/images/icons/HC-icons/diabetes/feeling-more-thirsty-than-usual.svg",
          },
          {
            id: 2,
            symptom: "Urinating often",
            icon: "/images/icons/HC-icons/diabetes/urinating-often.svg",
          },
          {
            id: 3,
            symptom: "Weight loss",
            icon: "/images/icons/HC-icons/diabetes/weight-loss.svg",
          },
          {
            id: 4,
            symptom: "Feeling tired and weak",
            icon: "/images/icons/HC-icons/diabetes/feeling-tired-and-weak.svg",
          },
          {
            id: 5,
            symptom: "Having blurry vision",
            icon: "/images/icons/HC-icons/diabetes/having-blurry-vision.svg",
          },
          {
            id: 6,
            symptom: "Having slow-healing wounds",
            icon: "/images/icons/HC-icons/diabetes/having-slow-healing-wounds.svg",
          },
          {
            id: 7,
            symptom: "Getting more infections",
            icon: "/images/icons/HC-icons/diabetes/getting-more-infections.svg",
          },
          // {
          //   id: 8,
          //   symptom: "Having numb/ tingling hands or feet",
          //   icon: "/images/icons/HC-icons/Diabetes/having-numb-tingling-hands-or-feet",
          // },
          {
            id: 9,
            symptom: "Having dry skin",
            icon: "/images/icons/HC-icons/diabetes/having-dry-skin.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Age over 35 years",
            icon: "/images/icons/HC-icons/diabetes/age-over-35-years.svg",
          },
          {
            id: 2,
            symptom: "Prediabetes ",
            icon: "/images/icons/HC-icons/diabetes/prediabetes.svg",
          },
          {
            id: 3,
            symptom: "Overweight or obese",
            icon: "/images/icons/HC-icons/diabetes/overweight-or-obese.svg",
          },
          {
            id: 4,
            symptom: "Family history of diabetes",
            icon: "/images/icons/HC-icons/diabetes/family-history-of-diabetes.svg",
          },
          {
            id: 5,
            symptom: "High cholesterol",
            icon: "/images/icons/HC-icons/diabetes/high-cholesterol.svg",
          },
          {
            id: 6,
            symptom: "High Blood Pressure",
            icon: "/images/icons/HC-icons/diabetes/high-blood-pressure.svg",
          },
          {
            id: 7,
            symptom: "Heart diseases",
            icon: "/images/icons/HC-icons/diabetes/heart-diseases.svg",
          },
          {
            id: 8,
            symptom: "Gestational diabetes",
            icon: "/images/icons/HC-icons/diabetes/gestational-diabetes.svg",
          },
          {
            id: 9,
            symptom: "Poly Cystic Ovarian Syndrome (PCOS)",
            icon: "/images/icons/HC-icons/diabetes/poly-cystic-ovarian-syndrome-PCOS.svg",
          },
        ],
      },
    ],
    diarrhealDiseases: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Loose or watery stools",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/loose-or-watery-stools.svg",
          },
          {
            id: 2,
            symptom: "Abdominal cramps ",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/abdominal-cramps.svg",
          },
          {
            id: 3,
            symptom: "Nausea or vomiting ",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/nausea-or-vomiting.svg",
          },
          {
            id: 4,
            symptom: "Dehydration",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/dehydration.svg",
          },
          {
            id: 5,
            symptom: "Fever",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/fever.svg",
          },
          {
            id: 6,
            symptom: "Weight loss",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/weight-loss.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Food poisoning ",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/food-poisoning.svg",
          },
          {
            id: 2,
            symptom: "Traveler's diarrhea ",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/travelers-diarrhea.svg",
          },
          {
            id: 3,
            symptom: "Stomach flu",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/stomach-flu.svg",
          },
          {
            id: 4,
            symptom: "Spicy food",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/spicy-food.svg",
          },
          {
            id: 5,
            symptom: "Poor personal hygiene",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/poor-personal-hygiene.svg",
          },
          {
            id: 6,
            symptom: "Celiac disease",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/celiac-disease.svg",
          },
          {
            id: 7,
            symptom: "Food allergy",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/food-allergy.svg",
          },
          {
            id: 8,
            symptom: "Food intolerance ",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/food-intolerance.svg",
          },
          {
            id: 9,
            symptom: "Inflammatory bowel disease",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/inflammatory-bowel-disease.svg",
          },
          {
            id: 10,
            symptom: "Genes",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/genes.svg",
          },
          {
            id: 11,
            symptom: "Medications",
            icon: "/images/icons/HC-icons/Diarrheal-Diseases/medications.svg",
          },
        ],
      },
    ],
    heartDisease: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Chest pain or discomfort",
            icon: "/images/icons/HC-icons/Heart-Disease/chest-pain-or-discomfort.svg",
          },
          {
            id: 2,
            symptom: "Upper back or neck pain",
            icon: "/images/icons/HC-icons/Heart-Disease/upper-back-or-neck-pain.svg",
          },
          {
            id: 3,
            symptom: "Indigestion ",
            icon: "/images/icons/HC-icons/Heart-Disease/indigestion.svg",
          },
          {
            id: 4,
            symptom: "Nausea or vomiting",
            icon: "/images/icons/HC-icons/Heart-Disease/nausea-or-vomiting.svg",
          },
          {
            id: 5,
            symptom: "Extreme fatigue",
            icon: "/images/icons/HC-icons/Heart-Disease/extreme-fatigue.svg",
          },
          {
            id: 6,
            symptom: "Shortness of breath",
            icon: "/images/icons/HC-icons/Heart-Disease/shortness-of-breath.svg",
          },
          {
            id: 7,
            symptom: "Palpitations in the chest",
            icon: "/images/icons/HC-icons/Heart-Disease/palpitations-in-the-chest.svg",
          },
          {
            id: 8,
            symptom: "Swelling of the feet, ankles, legs, or abdomen",
            icon: "/images/icons/HC-icons/Heart-Disease/swelling-of-the-feet-ankles-legs-or-abdomen.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Advancing age ",
            icon: "/images/icons/HC-icons/Heart-Disease/advancing-age.svg",
          },
          {
            id: 2,
            symptom: "Gender",
            icon: "/images/icons/HC-icons/Heart-Disease/gender.svg",
          },
          {
            id: 3,
            symptom: "Family history or genes",
            icon: "/images/icons/HC-icons/Heart-Disease/family-history-or-genes.svg",
          },
          {
            id: 4,
            symptom: "Race/ethnicity",
            icon: "/images/icons/HC-icons/Heart-Disease/race-ethnicity.svg",
          },
          {
            id: 5,
            symptom: "High blood pressure ",
            icon: "/images/icons/HC-icons/Heart-Disease/high-blood-pressure.svg",
          },
          {
            id: 6,
            symptom: "High blood cholesterol",
            icon: "/images/icons/HC-icons/Heart-Disease/high-blood-cholesterol.svg",
          },
          {
            id: 7,
            symptom: "Smoking ",
            icon: "/images/icons/HC-icons/Heart-Disease/smoking.svg",
          },
          {
            id: 8,
            symptom: "Diabetes  ",
            icon: "/images/icons/HC-icons/Heart-Disease/diabetes.svg",
          },
          {
            id: 9,
            symptom: "Overweight ",
            icon: "/images/icons/HC-icons/Heart-Disease/overweight.svg",
          },
          {
            id: 10,
            symptom: "Unhealthy diet ",
            icon: "/images/icons/HC-icons/Heart-Disease/unhealthy-diet.svg",
          },
          {
            id: 11,
            symptom: "Sedentary lifestyle",
            icon: "/images/icons/HC-icons/Heart-Disease/sedentary-lifestyle.svg",
          },
          {
            id: 12,
            symptom: "Excessive alcohol consumption ",
            icon: "/images/icons/HC-icons/Heart-Disease/excessive-alcohol-consumption.svg",
          },
        ],
      },
    ],
    hormonalProblemsInFemales: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Acne",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/acne.svg",
          },
          {
            id: 2,
            symptom: "Impaired Heartbeat",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/impaired-heartbeat.svg",
          },
          {
            id: 3,
            symptom: "Fatigue",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/fatigue.svg",
          },
          {
            id: 4,
            symptom: "Constipation ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/constipation.svg",
          },
          {
            id: 5,
            symptom: "Weight fluctuations (Loss or gain)",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/weight-fluctuations.svg",
          },
          {
            id: 6,
            symptom: "Numbness or tingling in hands",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/numbness-or-tingling-in-hands.svg",
          },
          {
            id: 7,
            symptom: "Diarrhoea",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/diarrhoea.svg",
          },
          {
            id: 8,
            symptom: "Anxiety",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/anxiety.svg",
          },
          {
            id: 9,
            symptom: "Depression",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/depression.svg",
          },
          {
            id: 10,
            symptom: "Skin problems",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/skin-problems.svg",
          },
          {
            id: 11,
            symptom: "Hair problems ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/hair-problems.svg",
          },
          {
            id: 12,
            symptom: "Irregular body fat distribution ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/irregular-body-fat-distribution.svg",
          },
          {
            id: 13,
            symptom: "Unusual body temperature",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/unusual-body-temperature.svg",
          },
          {
            id: 14,
            symptom: "Skin tags",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/skin-tags.svg",
          },
          {
            id: 15,
            symptom: "Extreme thirst",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/extreme-thirst.svg",
          },
          {
            id: 16,
            symptom: "Frequent urination ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/frequent-urination.svg",
          },
          {
            id: 17,
            symptom: "Darkened armpits, back and sides of neck ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/darkened-armpits-back-and-sides-of-neck.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Puberty",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/puberty.svg",
          },
          {
            id: 2,
            symptom: "Pregnancy",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/pregnancy.svg",
          },
          {
            id: 3,
            symptom: "Menopause ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/menopause.svg",
          },
          {
            id: 4,
            symptom: "Stress ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/stress.svg",
          },
          {
            id: 5,
            symptom: "Damage or injury to endocrine gland  ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/damage-or-injury-to-endocrine-gland.svg",
          },
          {
            id: 6,
            symptom: "Steroids use ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/steroids-use.svg",
          },
          {
            id: 7,
            symptom: "Certain autoimmune conditions",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Females/certain-autoimmune-conditions.svg",
          },
        ],
      },
    ],
    hormonalProblemsInMales: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Weight loss",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/weight-loss.svg",
          },
          {
            id: 2,
            symptom: "Fatigue",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/fatigue.svg",
          },
          {
            id: 3,
            symptom: "Hair loss",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/hair-loss.svg",
          },
          {
            id: 4,
            symptom: "Excessive sweating  ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/excessive-sweating.svg",
          },
          {
            id: 5,
            symptom: "Depression",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/depression.svg",
          },
          {
            id: 6,
            symptom: "Skin rashes",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/skin-rashes.svg",
          },
          {
            id: 7,
            symptom: "Frequent urination ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/frequent-urination.svg",
          },
          {
            id: 8,
            symptom: "Chest tenderness",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/chest-tenderness.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Age",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/age.svg",
          },
          {
            id: 2,
            symptom: "Stress condition",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/stress-condition.svg",
          },
          {
            id: 3,
            symptom: "Obesity ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/obesity.svg",
          },
          {
            id: 4,
            symptom: "Medical conditions",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/medical-conditions.svg",
          },
          {
            id: 5,
            symptom: "Genetics ",
            icon: "/images/icons/HC-icons/Hormonal-Problems-In-Males/genetics.svg",
          },
        ],
      },
    ],
    hypertension: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Severe headache",
            icon: "/images/icons/HC-icons/Hypertension/severe-headache.svg",
          },
          {
            id: 2,
            symptom: "Dizziness",
            icon: "/images/icons/HC-icons/Hypertension/dizziness.svg",
          },
          {
            id: 3,
            symptom: "Chest pain",
            icon: "/images/icons/HC-icons/Hypertension/chest-pain.svg",
          },
          {
            id: 4,
            symptom: "Nausea and vomiting ",
            icon: "/images/icons/HC-icons/Hypertension/nausea-and-vomiting.svg",
          },
          {
            id: 5,
            symptom: "Difficulty in breathing",
            icon: "/images/icons/HC-icons/Hypertension/difficulty-in-breathing.svg",
          },
          {
            id: 6,
            symptom: "Blurred and other vision changes",
            icon: "/images/icons/HC-icons/Hypertension/blurred-and-other-vision-changes.svg",
          },
          // {
          //   id: 7,
          //   symptom: "Nosebleeds",
          //   icon: "/images/icons/HC-icons/Hypertension/frequent-urination.svg",
          // },
          // {
          //   id: 8,
          //   symptom: "Anxiety",
          //   icon: "/images/icons/HC-icons/Hypertension/chest-tenderness.svg",
          // },
          {
            id: 9,
            symptom: "Abnormal heart rhythms",
            icon: "/images/icons/HC-icons/Hypertension/abnormal-heart-rhythms.svg",
          },
          {
            id: 10,
            symptom: "Buzzing in the ears",
            icon: "/images/icons/HC-icons/Hypertension/buzzing-in-the-ears.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Age (increases with age) ",
            icon: "/images/icons/HC-icons/Hypertension/age-(increases-with-age).svg",
          },
          // {
          //   id: 2,
          //   symptom: "Obesity or being overweight",
          //   icon: "/images/icons/HC-icons/Hypertension/stress-condition.svg",
          // },
          // {
          //   id: 3,
          //   symptom: "Smoking (tobacco or vaping)",
          //   icon: "/images/icons/HC-icons/Hypertension/obesity.svg",
          // },
          {
            id: 4,
            symptom: "Excess consumption of salt",
            icon: "/images/icons/HC-icons/Hypertension/excess-consumption-of-salt.svg",
          },
          {
            id: 5,
            symptom: "Sedentary lifestyle",
            icon: "/images/icons/HC-icons/Hypertension/sedentary-lifestyle.svg",
          },
          {
            id: 6,
            symptom: "Excess alcohol consumption",
            icon: "/images/icons/HC-icons/Hypertension/excess-alcohol-consumption.svg",
          },
          // {
          //   id: 7,
          //   symptom: "Low levels of potassium",
          //   icon: "/images/icons/HC-icons/Hypertension/genetics.svg",
          // },
          // {
          //   id: 8,
          //   symptom: "Stress",
          //   icon: "/images/icons/HC-icons/Hypertension/genetics.svg",
          // },
          {
            id: 9,
            symptom: "History of chronic diseases",
            icon: "/images/icons/HC-icons/Hypertension/history-of-chronic-diseases.svg",
          },
          {
            id: 10,
            symptom: "Pregnancy",
            icon: "/images/icons/HC-icons/Hypertension/pregnancy.svg",
          },
          // {
          //   id: 11,
          //   symptom: "Family history of hypertension",
          //   icon: "/images/icons/HC-icons/Hypertension/genetics.svg",
          // },
        ],
      },
    ],
    infectiousDiseases: [
      {
        symptoms: [
          // {
          //   id: 1,
          //   symptom: "Fever",
          //   icon: "/images/icons/HC-icons/Infectious-Diseases/Fever.svg",
          // },
          // {
          //   id: 2,
          //   symptom: "Shortness of breath",
          //   icon: "/images/icons/HC-icons/Infectious-Diseases/dizziness.svg",
          // },
          // {
          //   id: 3,
          //   symptom: "Cough",
          //   icon: "/images/icons/HC-icons/Infectious-Diseases/chest-pain.svg",
          // },
          // {
          //   id: 4,
          //   symptom: "Fatigue",
          //   icon: "/images/icons/HC-icons/Infectious-Diseases/nausea-and-vomiting.svg",
          // },
          // {
          //   id: 5,
          //   symptom: "Diarrhea",
          //   icon: "/images/icons/HC-icons/Infectious-Diseases/difficulty-in-breathing.svg",
          // },
          // {
          //   id: 6,
          //   symptom: "Vomiting",
          //   icon: "/images/icons/HC-icons/Infectious-Diseases/blurred-and-other-vision-changes.svg",
          // },
          {
            id: 7,
            symptom: "Nasal congestion",
            icon: "/images/icons/HC-icons/Infectious-Diseases/nasal-congestion.svg",
          },
          // {
          //   id: 8,
          //   symptom: "Chills and sweats",
          //   icon: "/images/icons/HC-icons/Infectious-Diseases/chest-tenderness.svg",
          // },
          {
            id: 9,
            symptom: "Mouth sores",
            icon: "/images/icons/HC-icons/Infectious-Diseases/mouth-sores.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "On medications or steroids",
            icon: "/images/icons/HC-icons/Infectious-Diseases/on-medications-or-steroids.svg",
          },
          {
            id: 2,
            symptom: "Having HIV or AIDS",
            icon: "/images/icons/HC-icons/Infectious-Diseases/having-HIV-or-AIDS.svg",
          },
          // {
          //   id: 3,
          //   symptom: "Who are pregnant and young children",
          //   icon: "/images/icons/HC-icons/Infectious-Diseases/obesity.svg",
          // },
          {
            id: 4,
            symptom: "Undergoing treatment for cancer",
            icon: "/images/icons/HC-icons/Infectious-Diseases/undergoing-treatment-for-cancer.svg",
          },
          {
            id: 5,
            symptom: "Unvaccinated against common infectious diseases",
            icon: "/images/icons/HC-icons/Infectious-Diseases/unvaccinated-against-common-infectious-diseases.svg",
          },
        ],
      },
    ],
    infertilityFemales: [
      {
        riskFactors: [
          {
            id: 1,
            symptom: "Older age",
            icon: "/images/icons/HC-icons/Infertility-Females/older-age.svg",
          },
          {
            id: 2,
            symptom: "Hormone issues",
            icon: "/images/icons/HC-icons/Infertility-Females/hormone-issues.svg",
          },
          {
            id: 3,
            symptom: "Abnormal menstrual cycle",
            icon: "/images/icons/HC-icons/Infertility-Females/abnormal-menstrual-cycle.svg",
          },
          // {
          //   id: 4,
          //   symptom: "Obesity",
          //   icon: "/images/icons/HC-icons/Infertility-Females/undergoing-treatment-for-cancer.svg",
          // },
          {
            id: 5,
            symptom: "Being underweight",
            icon: "/images/icons/HC-icons/Infertility-Females/being-underweight.svg",
          },
          {
            id: 6,
            symptom: "Endometriosis",
            icon: "/images/icons/HC-icons/Infertility-Females/endometriosis.svg",
          },
          {
            id: 7,
            symptom:
              "Problems with the structure of fallopian tubes, uterus, or ovaries",
            icon: "/images/icons/HC-icons/Infertility-Females/problems-with-the-structure.svg",
          },
          {
            id: 8,
            symptom: "Uterine fibroids",
            icon: "/images/icons/HC-icons/Infertility-Females/uterine-fibroids.svg",
          },
          // {
          //   id: 9,
          //   symptom: "Autoimmune disorders ",
          //   icon: "/images/icons/HC-icons/Infertility-Females/unvaccinated-against-common-infectious-diseases.svg",
          // },
          {
            id: 10,
            symptom: "Sexually transmitted infections",
            icon: "/images/icons/HC-icons/Infertility-Females/sexually-transmitted-infections.svg",
          },
          {
            id: 11,
            symptom: "Polycystic Ovary Syndrome ",
            icon: "/images/icons/HC-icons/Infertility-Females/polycystic-ovary-syndrome.svg",
          },
          // {
          //   id: 12,
          //   symptom: "Excessive alcohol consumption",
          //   icon: "/images/icons/HC-icons/Infertility-Females/unvaccinated-against-common-infectious-diseases.svg",
          // },
          // {
          //   id: 13,
          //   symptom: "Smoking",
          //   icon: "/images/icons/HC-icons/Infertility-Females/unvaccinated-against-common-infectious-diseases.svg",
          // },
        ],
      },
    ],
    infertilityMales: [
      {
        symptoms: [
          // {
          //   id: 1,
          //   symptom: "Erectile dysfunction",
          //   icon: "/images/icons/HC-icons/Infertility-Males/Fever.svg",
          // },
          {
            id: 2,
            symptom: "Loss of smell",
            icon: "/images/icons/HC-icons/Infertility-Males/loss-of-smell.svg",
          },
          {
            id: 3,
            symptom: "Gynecomastia (Abnormal growth of breast)",
            icon: "/images/icons/HC-icons/Infertility-Males/gynecomastia.svg",
          },
          {
            id: 4,
            symptom: "Low sperm count ",
            icon: "/images/icons/HC-icons/Infertility-Males/low-sperm-count.svg",
          },
          {
            id: 5,
            symptom: "Reduced facial and body hair growth ",
            icon: "/images/icons/HC-icons/Infertility-Males/reduced-facial-and-body-hair-growth.svg",
          },
          {
            id: 6,
            symptom: "Pain/swelling in testicles ",
            icon: "/images/icons/HC-icons/Infertility-Males/pain-swelling-in-testicles.svg",
          },
          {
            id: 7,
            symptom: "Frequent respiratory infections ",
            icon: "/images/icons/HC-icons/Infertility-Males/frequent-respiratory-infections.svg",
          },
        ],
        riskFactors: [
          // {
          //   id: 1,
          //   symptom: "Smoking",
          //   icon: "/images/icons/HC-icons/Infertility-Males/on-medications-or-steroids.svg",
          // },
          // {
          //   id: 2,
          //   symptom: "Alcohol intake",
          //   icon: "/images/icons/HC-icons/Infertility-Males/having-HIV-or-AIDS.svg",
          // },
          {
            id: 3,
            symptom: "Illicit drug use",
            icon: "/images/icons/HC-icons/Infertility-Males/illicit-drug-use.svg",
          },
          {
            id: 4,
            symptom: "Overheating of testicles",
            icon: "/images/icons/HC-icons/Infertility-Males/overheating-of-testicles.svg",
          },
          {
            id: 5,
            symptom: "Obesity",
            icon: "/images/icons/HC-icons/Infertility-Males/obesity.svg",
          },
          {
            id: 6,
            symptom: "Exposure to toxins ",
            icon: "/images/icons/HC-icons/Infertility-Males/exposure-to-toxins.svg",
          },
          {
            id: 7,
            symptom: "Injury to testicles ",
            icon: "/images/icons/HC-icons/Infertility-Males/injury-to-testicles.svg",
          },
          {
            id: 8,
            symptom: "Vasectomy or other pelvic surgeries",
            icon: "/images/icons/HC-icons/Infertility-Males/vasectomy-or-other-pelvic-surgeries.svg",
          },
          {
            id: 9,
            symptom: "Born with a fertility disorder",
            icon: "/images/icons/HC-icons/Infertility-Males/born-with-a-fertility-disorder.svg",
          },
          {
            id: 10,
            symptom: "Having tumors and chronic illnesses",
            icon: "/images/icons/HC-icons/Infertility-Males/having-tumors-and-chronic-illnesses.svg",
          },
          {
            id: 11,
            symptom: "Using certain medications",
            icon: "/images/icons/HC-icons/Infertility-Males/using-certain-medications.svg",
          },
        ],
      },
    ],
    inflammatoryBowelDisease: [
      {
        symptoms: [
          // {
          //   id: 1,
          //   symptom: "Abdominal pain and cramps",
          //   icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/Fever.svg",
          // },
          // {
          //   id: 2,
          //   symptom: "Diarrhoea",
          //   icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/loss-of-smell.svg",
          // },
          // {
          //   id: 3,
          //   symptom: "Fatigue",
          //   icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/gynecomastia.svg",
          // },
          {
            id: 4,
            symptom: "Fever",
            icon: "/images/icons/HC-icons/similar/fever.svg",
          },
          // {
          //   id: 5,
          //   symptom: "Nausea and vomiting ",
          //   icon: "/images/icons/HC-icons/similar/reduced-facial-and-body-hair-growth.svg",
          // },
          // {
          //   id: 6,
          //   symptom: "Blood or mucus in your stool ",
          //   icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/pain-swelling-in-testicles.svg",
          // },
          {
            id: 7,
            symptom: "loss of appetite ",
            icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/loss-of-appetite.svg",
          },
          // {
          //   id: 8,
          //   symptom: "Unexplained weight loss ",
          //   icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/frequent-respiratory-infections.svg",
          // },
          {
            id: 9,
            symptom: "Bloating and gas  ",
            icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/bloating-and-gas.svg",
          },
          {
            id: 10,
            symptom: "Painful and itchy eyes ",
            icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/painful-and-itchy-eyes.svg",
          },
          {
            id: 11,
            symptom: "Joint pains ",
            icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/joint-pains.svg",
          },
          {
            id: 12,
            symptom: "Skin rashes  ",
            icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/skin-rashes.svg",
          },
          {
            id: 13,
            symptom: "Ulcers (sores) ",
            icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/uicers-(sores).svg",
          },
          // {
          //   id: 14,
          //   symptom: "Vision problems ",
          //   icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/frequent-respiratory-infections.svg",
          // },
        ],
        riskFactors: [
          // {
          //   id: 1,
          //   symptom: "Age (diagnosed mostly before 30 years)",
          //   icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/on-medications-or-steroids.svg",
          // },
          {
            id: 2,
            symptom: "Smoking",
            icon: "/images/icons/HC-icons/similar/smoking.svg",
          },
          // {
          //   id: 3,
          //   symptom: "Using Nonsteroidal anti-inflammatory drugs (NSAIDs)",
          //   icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/illicit-drug-use.svg",
          // },
          // {
          //   id: 4,
          //   symptom: "Family history of IBD",
          //   icon: "/images/icons/HC-icons/Inflammatory-Bowel-Disease/overheating-of-testicles.svg",
          // },
        ],
      },
    ],
    kidneyDiseases: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Nausea and vomiting",
            icon: "/images/icons/HC-icons/similar/vomiting.svg",
          },
          {
            id: 2,
            symptom: "Loss of appetite",
            icon: "/images/icons/HC-icons/similar/loss-of-smell.svg",
          },
          {
            id: 3,
            symptom: "Fatigue",
            icon: "/images/icons/HC-icons/similar/gynecomastia.svg",
          },
          {
            id: 4,
            symptom: "Sleep problems",
            icon: "/images/icons/HC-icons/Kidney-Diseases/sleep-problems.svg",
          },
          {
            id: 5,
            symptom: "Urinating less or more ",
            icon: "/images/icons/HC-icons/similar/reduced-facial-and-body-hair-growth.svg",
          },
          {
            id: 6,
            symptom: "Muscle cramps",
            icon: "/images/icons/HC-icons/Kidney-Diseases/muscle-cramps.svg",
          },
          {
            id: 7,
            symptom: "Swelling of ankles and feet ",
            icon: "/images/icons/HC-icons/Kidney-Diseases/loss-of-appetite.svg",
          },
          {
            id: 8,
            symptom: "Dry, itchy skin ",
            icon: "/images/icons/HC-icons/Kidney-Diseases/frequent-respiratory-infections.svg",
          },
          {
            id: 9,
            symptom: "High blood pressure  ",
            icon: "/images/icons/HC-icons/Kidney-Diseases/high-blood-pressure.svg",
          },
          {
            id: 10,
            symptom: "Shortness of breath, if fluid accumulates in the lungs  ",
            icon: "/images/icons/HC-icons/Kidney-Diseases/painful-and-itchy-eyes.svg",
          },
          {
            id: 11,
            symptom:
              "Chest pain, if fluid accumulates around the heart's lining ",
            icon: "/images/icons/HC-icons/Kidney-Diseases/chest-pain.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Diabetes",
            icon: "/images/icons/HC-icons/similar/diabetes.svg",
          },
          {
            id: 2,
            symptom: "High blood pressure",
            icon: "/images/icons/HC-icons/similar/smoking.svg",
          },
          {
            id: 3,
            symptom: "Family history of kidney failure",
            icon: "/images/icons/HC-icons/similar/family-history.svg",
          },
          {
            id: 4,
            symptom: "Advancing age",
            icon: "/images/icons/HC-icons/Kidney-Diseases/overheating-of-testicles.svg",
          },
          {
            id: 5,
            symptom:
              "Belong to an ethnicity with a high prevalence of diabetes",
            icon: "/images/icons/HC-icons/kidney-Diseases/diabetes.svg",
          },
        ],
      },
    ],
    liverDiseases: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Jaundice",
            icon: "/images/icons/HC-icons/Liver-Diseases/jaundice.svg",
          },
          // {
          //   id: 2,
          //   symptom: "Stomach pain, especially on the right side",
          //   icon: "/images/icons/HC-icons/similar/loss-of-smell.svg",
          // },
          {
            id: 3,
            symptom: "Easy bruising",
            icon: "/images/icons/HC-icons/Liver-Diseases/easy-bruising.svg",
          },
          // {
          //   id: 4,
          //   symptom: "Sleep problems",
          //   icon: "/images/icons/HC-icons/similar/sleep-problems.svg",
          // },
          {
            id: 5,
            symptom: "Changes in urine or stool colour ",
            icon: "/images/icons/HC-icons/Liver-Diseases/changes-in-urine-or-stool-colour.svg",
          },
          {
            id: 6,
            symptom: "Fatigue",
            icon: "/images/icons/HC-icons/similar/fatigue.svg",
          },
          // {
          //   id: 7,
          //   symptom: "Nausea or vomiting ",
          //   icon: "/images/icons/HC-icons/similar/vomiting.svg",
          // },
          // {
          //   id: 8,
          //   symptom: "Diarrhea ",
          //   icon: "/images/icons/HC-icons/similar/diarrhea.svg",
          // },
          // {
          //   id: 9,
          //   symptom: "Loss of appetite",
          //   icon: "/images/icons/HC-icons/similar/Loss-of-appetite.svg",
          // },
          // {
          //   id: 10,
          //   symptom: "Swelling in arms or legs",
          //   icon: "/images/icons/HC-icons/similar/painful-and-itchy-eyes.svg",
          // },
        ],
        riskFactors: [
          // {
          //   id: 1,
          //   symptom: "Excessive alcohol consumption",
          //   icon: "/images/icons/HC-icons/similar/excessive-alcohol-consumption.svg",
          // },
          // {
          //   id: 2,
          //   symptom: "Obesity",
          //   icon: "/images/icons/HC-icons/similar/obesity.svg",
          // },
          // {
          //   id: 3,
          //   symptom: "Type 2 diabetes",
          //   icon: "/images/icons/HC-icons/Liver-Diseases/type-2-diabetes.svg",
          // },
          // {
          //   id: 4,
          //   symptom: "Tattoos or body piercings",
          //   icon: "/images/icons/HC-icons/Liver-Diseases/tattoos.svg",
          // },
          {
            id: 5,
            symptom: "Using shared needles",
            icon: "/images/icons/HC-icons/Liver-Diseases/using-shared-needles.svg",
          },
          {
            id: 6,
            symptom:
              "Exposure to an infected individual's blood and body fluids",
            icon: "/images/icons/HC-icons/Liver-Diseases/exposure-to-an-infected-individual's.svg",
          },
          {
            id: 7,
            symptom: "Unprotected sex",
            icon: "/images/icons/HC-icons/Liver-Diseases/unprotected-sex.svg",
          },
          {
            id: 8,
            symptom: "Exposure to certain chemicals or toxins",
            icon: "/images/icons/HC-icons/Liver-Diseases/exposure-to-certain-chemicals-or-toxins.svg",
          },
          {
            id: 9,
            symptom: "Family history of liver disease",
            icon: "/images/icons/HC-icons/similar/family-history.svg",
          },
        ],
      },
    ],
    nutritionalDeficiencies: [
      {
        symptoms: [
          // {
          //   id: 1,
          //   symptom: "Fatigue",
          //   icon: "/images/icons/HC-icons/Nutritional-Deficiencies/fatigue.svg",
          // },
          // {
          //   id: 2,
          //   symptom: "Constipation",
          //   icon: "/images/icons/HC-icons/similar/loss-of-smell.svg",
          // },
          {
            id: 3,
            symptom: "Severe hair loss",
            icon: "/images/icons/HC-icons/Nutritional-Deficiencies/severe-hair-loss.svg",
          },
          // {
          //   id: 4,
          //   symptom: "Poor sleep or concentration",
          //   icon: "/images/icons/HC-icons/similar/sleep-problems.svg",
          // },
          {
            id: 5,
            symptom: "Weakening of night vision ",
            icon: "/images/icons/HC-icons/Nutritional-Deficiencies/weakening-of-night-vision.svg",
          },
          {
            id: 6,
            symptom: "Burning sensation in the feet or tongue",
            icon: "/images/icons/HC-icons/Nutritional-Deficiencies/burning-sensation.svg",
          },
          {
            id: 7,
            symptom: "Slow healing of wounds ",
            icon: "/images/icons/HC-icons/Nutritional-Deficiencies/slow-healing-of-wounds.svg",
          },
          {
            id: 8,
            symptom: "Pain in bones and joints",
            icon: "/images/icons/HC-icons/Nutritional-Deficiencies/pain-in-bones-and-joints.svg",
          },
          {
            id: 9,
            symptom: "Irregular heartbeat",
            icon: "/images/icons/HC-icons/Nutritional-Deficiencies/irregular-heartbeat.svg",
          },
          {
            id: 10,
            symptom: "Menstrual issues",
            icon: "/images/icons/HC-icons/Nutritional-Deficiencies/menstrual-issues.svg",
          },
        ],
        riskFactors: [
          // {
          //   id: 1,
          //   symptom: "Fragile skin",
          //   icon: "/images/icons/HC-icons/similar/excessive-alcohol-consumption.svg",
          // },
          // {
          //   id: 2,
          //   symptom: "Poor appetite",
          //   icon: "/images/icons/HC-icons/similar/obesity.svg",
          // },
          // {
          //   id: 3,
          //   symptom: "Impaired swallowing ",
          //   icon: "/images/icons/HC-icons/Nutritional-Deficiencies/type-2-diabetes.svg",
          // },
          // {
          //   id: 4,
          //   symptom: "Alterations in bowel habit",
          //   icon: "/images/icons/HC-icons/Nutritional-Deficiencies/tattoos.svg",
          // },
          {
            id: 5,
            symptom: "Thinning of muscle mass",
            icon: "/images/icons/HC-icons/Nutritional-Deficiencies/thinning-of-muscle-mass.svg",
          },
          {
            id: 6,
            symptom: "Persistent illness",
            icon: "/images/icons/HC-icons/Nutritional-Deficiencies/persistent-illness.svg",
          },
        ],
      },
    ],
    obesity: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Breathlessness",
            icon: "/images/icons/HC-icons/Obesity/breathlessness.svg",
          },
          {
            id: 2,
            symptom: "Increased sweating",
            icon: "/images/icons/HC-icons/Obesity/increased-sweating.svg",
          },
          {
            id: 3,
            symptom: "Snoring",
            icon: "/images/icons/HC-icons/Obesity/snoring.svg",
          },
          {
            id: 4,
            symptom: "Difficulty doing exercise",
            icon: "/images/icons/HC-icons/Obesity/difficulty-doing-exercise.svg",
          },
          {
            id: 5,
            symptom: "Fatigue ",
            icon: "/images/icons/HC-icons/similar/fatigue.svg",
          },
          {
            id: 6,
            symptom: "Joint and back pain",
            icon: "/images/icons/HC-icons/Obesity/joint-and-back-pain.svg",
          },
          {
            id: 7,
            symptom: "Low confidence and self-esteem ",
            icon: "/images/icons/HC-icons/Obesity/low-confidence-and-self-esteem.svg",
          },
          {
            id: 8,
            symptom: "Feelings of loneliness",
            icon: "/images/icons/HC-icons/Obesity/feelings-of-loneliness.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Fast and convenient-to-cook foods",
            icon: "/images/icons/HC-icons/Obesity/fast-and-convenient-to-cook foods.svg",
          },
          {
            id: 2,
            symptom: "Foods containing high amounts of sugars",
            icon: "/images/icons/HC-icons/Obesity/foods-containing-high-amounts-of-sugars.svg",
          },
          {
            id: 3,
            symptom: "Certain hormones ",
            icon: "/images/icons/HC-icons/Obesity/certain-hormones.svg",
          },
          {
            id: 4,
            symptom: "Sedentary lifestyle",
            icon: "/images/icons/HC-icons/Obesity/sedentary-lifestyle.svg",
          },
          {
            id: 5,
            symptom: "Difficulty sleeping",
            icon: "/images/icons/HC-icons/Obesity/difficulty-sleeping.svg",
          },
          {
            id: 6,
            symptom: "Stress",
            icon: "/images/icons/HC-icons/Obesity/stress.svg",
          },
          {
            id: 7,
            symptom: "Depression",
            icon: "/images/icons/HC-icons/Obesity/depression.svg",
          },
          {
            id: 8,
            symptom: "Family history of obesity",
            icon: "/images/icons/HC-icons/Obesity/family-history-of-obesity.svg",
          },
          {
            id: 9,
            symptom: "Certain medications (Example: antidepressants, steroids)",
            icon: "/images/icons/HC-icons/Obesity/certain-medications.svg",
          },
          {
            id: 10,
            symptom:
              "Certain medical conditions (Example: Diabetes, Thyroid, etc.) ",
            icon: "/images/icons/HC-icons/Obesity/certain-medical-conditions.svg",
          },
        ],
      },
    ],
    pregnancy: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Missed periods",
            icon: "/images/icons/HC-icons/Pregnancy/missed-periods.svg",
          },
          {
            id: 2,
            symptom: "Morning sickness (Nausea and Vomiting)",
            icon: "/images/icons/HC-icons/Pregnancy/morning-sickness.svg",
          },
          {
            id: 3,
            symptom: "Breast changes",
            icon: "/images/icons/HC-icons/Pregnancy/breast-changes.svg",
          },
          {
            id: 4,
            symptom: "Fatigue",
            icon: "/images/icons/HC-icons/similar/fatigue.svg",
          },
          {
            id: 5,
            symptom: "Frequent urination at night ",
            icon: "/images/icons/HC-icons/Pregnancy/frequent-urination-at-night.svg",
          },
          {
            id: 6,
            symptom: "Food cravings",
            icon: "/images/icons/HC-icons/Pregnancy/food-cravings.svg",
          },
          {
            id: 7,
            symptom: "Backache ",
            icon: "/images/icons/HC-icons/Pregnancy/backache.svg",
          },
          // {
          //   id: 8,
          //   symptom: "Breathlessness",
          //   icon: "/images/icons/HC-icons/similar/breathlessness.svg",
          // },
        ],
      },
    ],
    respiratoryDiseases: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Shortness of breath",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/shortness-of-breath.svg",
          },
          {
            id: 2,
            symptom: "Tightness in the chest",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/tightness-in-the-chest.svg",
          },
          {
            id: 3,
            symptom: "Wheezing",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/wheezing.svg",
          },
          {
            id: 4,
            symptom: "Chronic cough",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/chronic-cough.svg",
          },
          {
            id: 5,
            symptom: "Blood in sputum ",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/blood-in-sputum.svg",
          },
          {
            id: 6,
            symptom: "Frequent respiratory infections",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/frequent-respiratory-infections.svg",
          },
          {
            id: 7,
            symptom: "Lack of energy ",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/lack-of-energy.svg",
          },
          {
            id: 8,
            symptom: "Unintended weight loss ",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/unintended-weight-loss.svg",
          },
          {
            id: 9,
            symptom: "Swelling in legs, feet, or ankles",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/swelling-in-legs-feet-or-ankles.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Age",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/age.svg",
          },
          {
            id: 2,
            symptom: "Air pollution",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/air-pollution.svg",
          },
          {
            id: 3,
            symptom: "Allergens  ",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/allergens.svg",
          },
          {
            id: 4,
            symptom: "Asbestos",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/asbestos.svg",
          },
          {
            id: 5,
            symptom: "Artificially produced dyes and paints",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/artificially-produced-dyes-and-paints.svg",
          },
          {
            id: 6,
            symptom: "Chemical fumes",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/chemical-fumes.svg",
          },
          {
            id: 7,
            symptom: "Cigarette smoke ",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/cigarette-smoke.svg",
          },
          {
            id: 8,
            symptom: "Dust",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/dust.svg",
          },
          {
            id: 9,
            symptom: "Family history",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/family-history.svg",
          },
          {
            id: 10,
            symptom: "Occupational hazards ",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/occupational-hazards.svg",
          },
          {
            id: 11,
            symptom: "Secondhand smoke ",
            icon: "/images/icons/HC-icons/Respiratory-Diseases/secondhand-smoke.svg",
          },
        ],
      },
    ],
    skinProblems: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Dry skin",
            icon: "/images/icons/HC-icons/Skin-Problems/dry-skin.svg",
          },
          {
            id: 2,
            symptom: "Discoloured skin patches",
            icon: "/images/icons/HC-icons/Skin-Problems/discoloured-skin-patches.svg",
          },
          {
            id: 3,
            symptom: "Peeling skin",
            icon: "/images/icons/HC-icons/Skin-Problems/peeling-skin.svg",
          },
          {
            id: 4,
            symptom: "Ulcers",
            icon: "/images/icons/HC-icons/Skin-Problems/ulcers.svg",
          },
          {
            id: 5,
            symptom: "Rashes ",
            icon: "/images/icons/HC-icons/Skin-Problems/rashes.svg",
          },
          {
            id: 6,
            symptom: "Itchiness",
            icon: "/images/icons/HC-icons/Skin-Problems/itchiness.svg",
          },
          {
            id: 7,
            symptom: "Pus-filled bumps ",
            icon: "/images/icons/HC-icons/Skin-Problems/pus-filled-bumps.svg",
          },
          {
            id: 8,
            symptom: "Scaly or rough skin ",
            icon: "/images/icons/HC-icons/Skin-Problems/scaly-or-rough-skin.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom: "Family history",
            icon: "/images/icons/HC-icons/Skin-Problems/family-history.svg",
          },
          {
            id: 2,
            symptom: "Multiple/atypical moles",
            icon: "/images/icons/HC-icons/Skin-Problems/multiple-atypical-moles.svg",
          },
          {
            id: 3,
            symptom: "Exposure to UV or X-rays  ",
            icon: "/images/icons/HC-icons/Skin-Problems/exposure-to-UV-or-X-rays.svg",
          },
          {
            id: 4,
            symptom: "Scars from diseases or burns",
            icon: "/images/icons/HC-icons/Skin-Problems/scars-from-diseases-or-burns.svg",
          },
          {
            id: 5,
            symptom: "Immune suppression medications",
            icon: "/images/icons/HC-icons/Skin-Problems/immune-suppression-medications.svg",
          },
          {
            id: 6,
            symptom: "Older age",
            icon: "/images/icons/HC-icons/Skin-Problems/older-age.svg",
          },
          {
            id: 7,
            symptom: "History of skin diseases ",
            icon: "/images/icons/HC-icons/Skin-Problems/history-of-skin-diseases.svg",
          },
          {
            id: 8,
            symptom: "Smoking ",
            icon: "/images/icons/HC-icons/Skin-Problems/smoking.svg",
          },
          {
            id: 9,
            symptom: "Infections",
            icon: "/images/icons/HC-icons/Skin-Problems/infections.svg",
          },
        ],
      },
    ],
    sleepProblems: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Difficulty in falling asleep",
            icon: "/images/icons/HC-icons/Sleep-Problems/difficulty-in-falling-asleep.svg",
          },
          // {
          //   id: 2,
          //   symptom:
          //     "Difficulty sleeping again after waking up in the middle of the night ",
          //   icon: "/images/icons/HC-icons/Sleep-Problems/difficulty-sleeping-again-after-waking-up.svg",
          // },
          // {
          //   id: 3,
          //   symptom: "Experiencing unusual breathing patterns ",
          //   icon: "/images/icons/HC-icons/Sleep-Problems/peeling-skin.svg",
          // },
          {
            id: 4,
            symptom: "Episodes of sudden muscle weakness ",
            icon: "/images/icons/HC-icons/Sleep-Problems/episodes-of-sudden-muscle-weakness.svg",
          },
          {
            id: 5,
            symptom: "Following inappropriate sleep schedule ",
            icon: "/images/icons/HC-icons/Sleep-Problems/following-inappropriate-sleep-schedule.svg",
          },
          // {
          //   id: 6,
          //   symptom: "Lack of concentration",
          //   icon: "/images/icons/HC-icons/Sleep-Problems/itchiness.svg",
          // },
          {
            id: 7,
            symptom: "Increased irritability ",
            icon: "/images/icons/HC-icons/Sleep-Problems/increased-irritability.svg",
          },
        ],
        riskFactors: [
          // {
          //   id: 1,
          //   symptom: "Age",
          //   icon: "/images/icons/HC-icons/Sleep-Problems/family-history.svg",
          // },
          {
            id: 2,
            symptom: "Gender",
            icon: "/images/icons/HC-icons/Sleep-Problems/gender.svg",
          },
          {
            id: 3,
            symptom: "Stress  ",
            icon: "/images/icons/HC-icons/Sleep-Problems/stress.svg",
          },
          // {
          //   id: 4,
          //   symptom: "Family history ",
          //   icon: "/images/icons/HC-icons/Sleep-Problems/scars-from-diseases-or-burns.svg",
          // },
          {
            id: 5,
            symptom: "Medical conditions",
            icon: "/images/icons/HC-icons/Sleep-Problems/medical-conditions.svg",
          },
          {
            id: 6,
            symptom: "Late working hours",
            icon: "/images/icons/HC-icons/Sleep-Problems/late-working-hours.svg",
          },
        ],
      },
    ],
    tuberculosis: [
      {
        symptoms: [
          {
            id: 1,
            symptom: "Cough for more than 3 weeks",
            icon: "/images/icons/HC-icons/Tuberculosis/cough-for-more-than-3 weeks.svg",
          },
          {
            id: 2,
            symptom: "Coughing of blood or sputum ",
            icon: "/images/icons/HC-icons/Tuberculosis/coughing-of-blood-or-sputum.svg",
          },
          {
            id: 3,
            symptom: "Fever  ",
            icon: "/images/icons/HC-icons/similar/fever.svg",
          },
          {
            id: 4,
            symptom: "Weight loss  ",
            icon: "/images/icons/HC-icons/Tuberculosis/weight-loss.svg",
          },
          {
            id: 5,
            symptom: "Fatigue ",
            icon: "/images/icons/HC-icons/Tuberculosis/fatigue.svg",
          },
          {
            id: 6,
            symptom: "Night sweats",
            icon: "/images/icons/HC-icons/Tuberculosis/night-sweats.svg",
          },
          {
            id: 7,
            symptom: "Headache  ",
            icon: "/images/icons/HC-icons/Tuberculosis/headache.svg",
          },
          {
            id: 8,
            symptom: "Joint pains  ",
            icon: "/images/icons/HC-icons/Tuberculosis/joint-pains.svg",
          },
          {
            id: 9,
            symptom: "Chills   ",
            icon: "/images/icons/HC-icons/Tuberculosis/chills.svg",
          },
          {
            id: 10,
            symptom: "Loss of appetite     ",
            icon: "/images/icons/HC-icons/Tuberculosis/loss-of-appetite.svg",
          },
          {
            id: 11,
            symptom: "Difficulty in breathing",
            icon: "/images/icons/HC-icons/Tuberculosis/difficulty-in-breathing.svg",
          },
          {
            id: 12,
            symptom: "Chest pain ",
            icon: "/images/icons/HC-icons/Tuberculosis/chest-pain.svg",
          },
        ],
        riskFactors: [
          {
            id: 1,
            symptom:
              "Living with an individual who is having an active TB infection",
            icon: "/images/icons/HC-icons/Tuberculosis/living-with-an-individual-who-is-having -an-active-TB-infection..svg",
          },
          {
            id: 2,
            symptom: "Travelling ",
            icon: "/images/icons/HC-icons/Tuberculosis/travelling-or-living-in-a-country.svg",
          },
          {
            id: 3,
            symptom:
              "Working or living in certain places such as nursing homes  ",
            icon: "/images/icons/HC-icons/Tuberculosis/working-or-living-in-certain-places.svg",
          },
          {
            id: 4,
            symptom: "Having health conditions such as diabetes ",
            icon: "/images/icons/HC-icons/Tuberculosis/havin-health-conditions.svg",
          },
        ],
      },
    ],
  },
];

